import { render } from "./home-banner.vue?vue&type=template&id=47e15500&scoped=true"
import script from "./home-banner.vue?vue&type=script&lang=js"
export * from "./home-banner.vue?vue&type=script&lang=js"

import "./home-banner.vue?vue&type=style&index=0&id=47e15500&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e15500"]])

export default __exports__